import { Typography } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

/**
 * Displays a cell with the id of a TypeExtension.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 * @returns {React.ReactNode}
 */
export const ListItemCellTypeExtensionExternalKey = (classes, props = {}) => {
  const { externalKey = '' } = props

  return (
    <Typography
      color={'black'}
      variant={'14/regular'}
      className={classes.row}
      sx={{ fontWeight: 700 }}
    >
      {externalKey}
    </Typography>
  )
}

export default CellHOC(ListItemCellTypeExtensionExternalKey)
